import vlog from '../../vlog';

export const V2_TEST_MOCKS_STORAGE_KEY = 'v2_test_mocks';

export const loadV2TestMocks = () => {
  if (window.RAILS_ENV !== 'test') {
    return null;
  }

  try {
    const stored = window.localStorage.getItem(V2_TEST_MOCKS_STORAGE_KEY);
    if (!stored) {
      return null;
    }

    return JSON.parse(stored);
  } catch (error) {
    vlog.warn('Unable to parse V2 test mocks from localStorage.', error);
    return null;
  }
};

export const buildMockSupabaseClient = (mocks) => ({
  // Realtime no-op: the inbox composer/thread subscribes to postgres_changes on mount;
  // without these stubs the mount throws and React tears down the whole section.
  channel: () => {
    const ch = {
      on: () => ch,
      subscribe: (callback) => {
        if (callback) callback('SUBSCRIBED');
        return ch;
      },
      unsubscribe: () => {},
    };
    return ch;
  },
  removeChannel: () => {},

  from: (table) => {
    const tableData = mocks[table] || [];

    const builder = {
      _data: tableData,
      _countOnly: false,
      select(columns, options) {
        if (options && options.count === 'exact' && options.head === true) {
          builder._countOnly = true;
        }
        return this;
      },
      eq() { return this; },
      neq() { return this; },
      in() { return this; },
      not() { return this; },
      order() { return this; },
      range() { return this; },
      limit() { return { data: builder._data, error: null }; },
      single() {
        const item = Array.isArray(builder._data) ? builder._data[0] : builder._data;
        if (item) {
          return { data: item, error: null };
        }
        return { data: null, error: { message: 'Not found' } };
      },
      maybeSingle() {
        const item = Array.isArray(builder._data) ? builder._data[0] : builder._data;
        return { data: item || null, error: null };
      },
      then(resolve) {
        if (builder._countOnly) {
          resolve({ count: Array.isArray(builder._data) ? builder._data.length : 0, error: null });
        } else {
          resolve({ data: builder._data, error: null });
        }
      },
    };

    return builder;
  },
});
